import { ListenerDataProvider } from "./ListenerData";
import { GoogleMapsProvider } from "./GoogleMaps";
import { DSGoogleMapsProvider } from "./DSGoogleMaps";

type AppProviderProps = {
  children: React.ReactNode;
};

export function AppProvider({ children }: AppProviderProps) {
  return (
    <ListenerDataProvider>
      <GoogleMapsProvider>
        <DSGoogleMapsProvider>{children}</DSGoogleMapsProvider>
      </GoogleMapsProvider>
    </ListenerDataProvider>
  );
}
